import { Injectable } from '@angular/core';
import { Profile } from 'core/models';

@Injectable()
export class GtmService {
  constructor() {}

  /**
   * Set the data layer for GTM
   * @param loggedUser
   * @param userLang
   * @param currentClient
   * @param selectedClientId
   */
  public setDataLayer(loggedUser: Profile | any, userLang: string, currentClient: any, selectedClientId: any): void {
    const {
      id,
      email: userEmail,
      role,
      countryId,
      created_at: userCreatedDate,
      isCreator,
      planType,
      planEndDate
    } = loggedUser;
    const { clientId, name: clientName, clientType } = currentClient;

    (window as any).dataLayer.push({
      event: 'data_info',
      userId: id,
      email: userEmail,
      role: role,
      language: userLang,
      countryId: countryId || 'unknown',
      platformId: clientId ? selectedClientId : 'unknown',
      // Send dates as YYYY-MM-DD (UTC)
      creationDate: userCreatedDate?.split('T')[0],
      editorAccess: isCreator,
      lmsAccess: true,
      planType: planType,
      planEndDate: planEndDate?.split('T')[0] || 'unknown',
      clientId: clientId || 'unknown',
      clientName: clientName || 'unknown',
      clientType: clientType || 'unknown'
    });
  }

  /**
   * Set the event to GTM
   */
  public setCookiesConfiguredAndNotifyGTM(): void {
    // Send the cookies consent event to dataLayer
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'consent_granted'
      });
    }
  }

  /**
   * Initialization GOOGLE TAG MANAGER
   */
  public activeGTagManager(): void {
    /* eslint-disable */
    const script = document.createElement('script');
    const startScriptComment = document.createComment('Google Tag Manager');
    const endScriptComment = document.createComment('End Google Tag Manager');

    script.type = 'text/javascript';
    script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-N8KZLB4");
    `;
    document.head.appendChild(startScriptComment);
    document.head.appendChild(script);
    document.head.appendChild(endScriptComment);

    const noScript = document.createElement('noscript');
    const startNoScriptComment = document.createComment('Google Tag Manager (noscript)');
    const endNoScriptComment = document.createComment('End Google Tag Manager (noscript)');
    noScript.innerHTML = `\<\iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N8KZLB4" height="0" width="0" style="display: none; visibility: hidden" ></iframe >`;
    document.body.appendChild(startNoScriptComment);
    document.body.appendChild(noScript);
    document.body.appendChild(endNoScriptComment);
    /* eslint-enable */
  }
}
